export const addTypeToRuleArguments = (ruleArgumentsMap: any) => {
    for (const key in ruleArgumentsMap) {
    const argument = ruleArgumentsMap[key];
    
            if (argument.ruleArgumentDataType === "MapOfStringTypeValue") {
                argument.__type = "com.amazon.tipscarrierconfiguration.structures#MapRuleArgumentData";
            } else if (argument.ruleArgumentDataType === "StringTypeValue") {
                argument.__type = "com.amazon.tipscarrierconfiguration.structures#PrimitiveRuleArgumentData";
            }
        }
    };

export const isDefaultGLMissing=(glRulesMap: any):boolean => {
    if (glRulesMap.defaultGl == null){
        return false
    } 
    return !glRulesMap.defaultGl?.value?.trim(); 
}